import axios, { AxiosError, AxiosResponse } from "axios";
import {
  Provincie,
  Region,
  ResponseGetProvincie,
  ResponseGetRegion,
} from "./interfaceRegion";
import { getHeaders } from "@/helpers/token/CaptureToken";

export const getRegion = async (): Promise<Region[]> => {
  try {
    const response: AxiosResponse = await axios.get(
      `https://api-admision.colegioae.edu.pe/api/cities/region`,
    );

    return response.data.data;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as Region[];
  }
};

export const getProvincie = async (): Promise<Provincie[]> => {
  try {
    const response: AxiosResponse = await axios.get(
      `https://api-admision.colegioae.edu.pe/api/cities/province`,
    );
    return response.data.data;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as Provincie[];
  }
};

export const getDistrict = async (): Promise<any[]> => {
  try {
    const response: AxiosResponse = await axios.get(
      `https://api-admision.colegioae.edu.pe/api/cities/district`,
    );
    return response.data.data;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as any[];
  }
};

export const getAllColegio = async (ubigeo?: string): Promise<any> => {
  const headers: any = await getHeaders();
  try {
    const response: AxiosResponse = await axios.get(
      `https://api-admision.colegioae.edu.pe/api/general/ubigean/${ubigeo}`,
      { headers },
    );
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as any;
  }
};
